import { Label, Tooltip } from '@customerio/pluma-components/react';
import { stateColor, stateDescription, stateLabel } from '../catalog';

type DeliveryStateTagProps = {
  /** The delivery state to display (typically `getDisplayState(delivery)`). */
  state: string;
  /** Channel value (`action_type` minus `_action`) — selects the `delivered` copy. */
  channel?: string;
};

/**
 * Colored status label for a delivery state, with a hover tooltip explaining
 * the state. Ported from the Ember `<delivery-state-tag>` + `state-label-map`:
 * `Label` + `showStatusIndicator` gives the same green/red/yellow/grey dot.
 */
export function DeliveryStateTag({ state, channel }: DeliveryStateTagProps) {
  const description = stateDescription(state, channel);
  const label = (
    <Label color={stateColor(state)} showStatusIndicator>
      {stateLabel(state)}
    </Label>
  );

  if (description == null) return label;

  return (
    <Tooltip content={description} placement="top">
      {label}
    </Tooltip>
  );
}
